// src/auth.js
import { ADMIN_LOGIN_PATH } from "./routes";

/** LocalStorage kalitlari (orqaga moslik saqlanadi) */
const LS_ACCESS = "access";
const LS_REFRESH = "refresh";
const LS_TOKEN_FALLBACK = "token"; // eski nom
const LS_USER = "user";

/** Ichki: ro‘lni normallashtiramiz (cashier => seller) */
function normRole(r) {
  const v = String(r || "").toLowerCase();
  if (v === "cashier") return "seller";
  return v;
}

/** Foydalanuvchini saqlash (access majburiy, refresh ixtiyoriy) */
export function saveAuth({ access, refresh, user }) {
  if (access) {
    localStorage.setItem(LS_ACCESS, access);
    // orqaga moslik
    localStorage.setItem(LS_TOKEN_FALLBACK, access);
  }
  if (typeof refresh !== "undefined") {
    if (refresh) localStorage.setItem(LS_REFRESH, refresh);
    else localStorage.removeItem(LS_REFRESH);
  }
  if (user) {
    // ro‘lni normallashtirib saqlaymiz
    const u = { ...user, role: normRole(user.role) };
    localStorage.setItem(LS_USER, JSON.stringify(u));
  }
}

/** Faqat user obyektini yangilash (masalan /me dan) */
export function saveUser(user) {
  const u = user ? { ...user, role: normRole(user.role) } : {};
  localStorage.setItem(LS_USER, JSON.stringify(u));
}

/** Tokenlarni o‘qish */
export function getToken() {
  // Avval access, bo‘lmasa eski token
  return (
    localStorage.getItem(LS_ACCESS) ||
    localStorage.getItem(LS_TOKEN_FALLBACK) ||
    ""
  );
}
export function getRefresh() {
  return localStorage.getItem(LS_REFRESH) || "";
}

/** Userni o‘qish (xatolarga chidamli) */
export function getUser() {
  try {
    const raw = localStorage.getItem(LS_USER) || localStorage.getItem("yt_user");
    const u = raw ? JSON.parse(raw) : {};
    // har ehtimolga qarshi normallashtiramiz
    if (u && u.role) u.role = normRole(u.role);
    return u || {};
  } catch {
    return {};
  }
}

/** Chiqish (frontend tomonini tozalash) */
export function logout() {
  localStorage.removeItem(LS_ACCESS);
  localStorage.removeItem(LS_REFRESH);
  localStorage.removeItem(LS_TOKEN_FALLBACK);
  localStorage.removeItem(LS_USER);
  localStorage.removeItem("yt_user");
  window.location.href = ADMIN_LOGIN_PATH;
}

/** Holat yordamchilari */
export function isAuthed() {
  return !!getToken();
}
export function hasRole(...roles) {
  const want = roles.map((x) => normRole(x));
  const have = normRole(getUser()?.role);
  return want.includes(have);
}
export function isAdmin() {
  return hasRole("admin");
}
export function isSeller() {
  return hasRole("seller", "cashier");
}

export function getWarehouseAccess() {
  const user = getUser() || {};
  const ids = Array.isArray(user.allowed_sklad_ids)
    ? user.allowed_sklad_ids
        .map((x) => Number(x))
        .filter((x) => Number.isFinite(x) && x > 0)
    : [];

  return {
    allAccess: user.all_sklad_access !== false,
    allowedIds: ids,
  };
}
